<template>
  <v-toolbar
    color="blue-grey darken-4"
    dark
    fixed
    app
    clipped-left
    class="app-toolbar app-toolbar--dark"
    elevation="0"
  >
    <!-- Hamburger menu -->
    <v-btn icon class="toolbar-icon-btn" @click.stop="handleDrawerToggle">
      <v-icon class="toolbar-icon">menu</v-icon>
    </v-btn>

    <!-- App name / page title -->
    <v-toolbar-title class="toolbar-title ml-1">
      <span class="toolbar-title__app">edPass</span>
      <span class="toolbar-title__sep">·</span>
      <span class="toolbar-title__page">Admin</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- Fullscreen toggle -->
    <v-btn icon class="toolbar-icon-btn" @click="handleFullScreen()">
      <v-icon class="toolbar-icon">fullscreen</v-icon>
    </v-btn>

    <!-- User menu -->
    <v-menu
      offset-y
      origin="top right"
      :nudge-bottom="8"
      transition="scale-transition"
      min-width="200"
    >
      <div slot="activator" class="toolbar-user">
        <div class="toolbar-avatar">
          {{ userInitials }}
        </div>
        <span class="toolbar-user__name hidden-sm-and-down">{{ userName }}</span>
        <v-icon small class="toolbar-user__caret hidden-sm-and-down">arrow_drop_down</v-icon>
      </div>

      <v-card class="toolbar-menu-card toolbar-menu-card--dark">
        <!-- User info header -->
        <div class="toolbar-menu-header">
          <div class="toolbar-menu-avatar">{{ userInitials }}</div>
          <div class="toolbar-menu-info">
            <div class="toolbar-menu-info__name">{{ userName }}</div>
            <div class="toolbar-menu-info__role">Administrator</div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-list class="pa-0">
          <v-list-tile
            v-for="(item, index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
            class="toolbar-menu-item"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon small class="toolbar-menu-item__icon">{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="toolbar-menu-item__title">{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </v-toolbar>
</template>

<script>
import Util from "@/util";
export default {
  name: "app-toolbar",
  data: () => ({
    items: [
      {
        icon: "exit_to_app",
        href: "#",
        title: "Sign Out",
        click: e => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ]
  }),
  computed: {
    userName() {
      try {
        const user = JSON.parse(localStorage.getItem("active_user") || "{}");
        return user.username || user.name || user.email || "Admin";
      } catch (e) {
        return "Admin";
      }
    },
    userInitials() {
      const name = this.userName;
      if (!name || name === "Admin") return "A";
      const parts = name.split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    }
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    }
  }
};
</script>

<style lang="stylus" scoped>
.app-toolbar
  border-bottom: 1px solid #e2e8f0 !important
  background: #ffffff !important

  &--dark
    border-bottom-color: rgba(255,255,255,0.08) !important
    background: #10202b !important

    .toolbar-icon-btn
      color: rgba(255,255,255,0.72) !important

      &:hover
        background: rgba(255,255,255,0.08) !important

    .toolbar-icon
      color: rgba(255,255,255,0.86) !important

    .toolbar-title__app
      color: #ffffff

    .toolbar-title__sep
      color: rgba(255,255,255,0.28)

    .toolbar-title__page,
    .toolbar-user__name
      color: rgba(255,255,255,0.68)

    .toolbar-user
      &:hover
        background: rgba(255,255,255,0.08)

    .toolbar-user__caret
      color: rgba(255,255,255,0.45) !important

.toolbar-icon-btn
  color: #64748b !important

  &:hover
    background: #f1f5f9 !important

.toolbar-icon
  color: #475569 !important
  font-size: 22px !important

.toolbar-title
  display: flex
  align-items: center
  gap: 6px

.toolbar-title__app
  font-family: 'Inter', 'Roboto', sans-serif
  font-weight: 700
  font-size: 16px
  color: #1e293b
  letter-spacing: -0.3px

.toolbar-title__sep
  color: #cbd5e1
  font-weight: 300
  font-size: 18px

.toolbar-title__page
  font-family: 'Inter', 'Roboto', sans-serif
  font-weight: 400
  font-size: 15px
  color: #64748b

.toolbar-user
  display: flex
  align-items: center
  cursor: pointer
  padding: 6px 10px
  border-radius: 10px
  transition: background 0.15s ease
  margin-left: 4px

  &:hover
    background: #f1f5f9

.toolbar-avatar
  width: 34px
  height: 34px
  border-radius: 50%
  background: linear-gradient(135deg, #1565C0, #0d47a1)
  color: #ffffff
  font-family: 'Inter', 'Roboto', sans-serif
  font-size: 13px
  font-weight: 600
  display: flex
  align-items: center
  justify-content: center
  letter-spacing: 0.5px
  flex-shrink: 0

.toolbar-user__name
  font-family: 'Inter', 'Roboto', sans-serif
  font-size: 14px
  font-weight: 500
  color: #334155
  margin-left: 10px

.toolbar-user__caret
  color: #94a3b8 !important
  margin-left: 2px

.toolbar-menu-card
  border-radius: 12px !important
  overflow: hidden
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.12) !important

  &--dark
    background: #132635 !important
    border: 1px solid rgba(255,255,255,0.08)
    box-shadow: 0 10px 36px rgba(0, 0, 0, 0.32) !important

    .toolbar-menu-info__name,
    .toolbar-menu-item__title
      color: rgba(255,255,255,0.88) !important

    .toolbar-menu-info__role,
    .toolbar-menu-item__icon
      color: rgba(255,255,255,0.52) !important

    .v-divider
      border-color: rgba(255,255,255,0.08) !important

    >>> .v-list
      background: transparent !important

    .toolbar-menu-item
      color: rgba(255,255,255,0.88) !important

      &:hover
        background: rgba(255,255,255,0.06) !important

    >>> .v-list__tile
      color: rgba(255,255,255,0.88) !important

.toolbar-menu-header
  display: flex
  align-items: center
  padding: 16px

.toolbar-menu-avatar
  width: 40px
  height: 40px
  border-radius: 50%
  background: linear-gradient(135deg, #1565C0, #0d47a1)
  color: #ffffff
  font-family: 'Inter', 'Roboto', sans-serif
  font-size: 15px
  font-weight: 600
  display: flex
  align-items: center
  justify-content: center
  flex-shrink: 0

.toolbar-menu-info
  margin-left: 12px

.toolbar-menu-info__name
  font-family: 'Inter', 'Roboto', sans-serif
  font-size: 14px
  font-weight: 600
  color: #1e293b

.toolbar-menu-info__role
  font-size: 12px
  color: #94a3b8
  margin-top: 1px

.toolbar-menu-item
  height: 44px !important

.toolbar-menu-item__icon
  color: #64748b !important

.toolbar-menu-item__title
  font-family: 'Inter', 'Roboto', sans-serif !important
  font-size: 14px !important
  font-weight: 500 !important
  color: #334155 !important
</style>
